import React from 'react'

interface AvatarProps {
  nickname: string
  profileImage?: string | null
  size?: number
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const Avatar: React.FC<AvatarProps> = ({
  nickname,
  profileImage,
  size = 56,
  onClick,
}) => {
  return (
    <div
      className={`rounded-full overflow-hidden bg-[#F1EBE4] flex-shrink-0 [&_img]:select-none [&_img]:[-webkit-touch-callout:none] ${
        onClick ? 'cursor-pointer' : ''
      }`}
      style={{ width: `${size}px`, height: `${size}px` }}
      onClick={onClick}
    >
      {profileImage ? (
        <img
          src={profileImage}
          alt={nickname}
          draggable={false}
          className="w-full h-full object-cover"
        />
      ) : (
        <img
          src="/images/profile-placeholder-icon.png"
          alt={nickname}
          draggable={false}
          className="w-full h-full object-cover opacity-80"
        />
      )}
    </div>
  )
}

export default Avatar
